import {createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as api from './companyAdminAPI';
import KPConfig from '../../KPConfig';

const initialState = {
  settings: [],
  didLoadCompanySettings: false, //Used in DocumentCreate and FolderView

  getCompanySettingsStatus: undefined,
};

export const getCompanySettings = createAsyncThunk(
  'companyAdmin/getCompanySettings',
  async (companyId) => {
    if (KPConfig.useNewBe) {
      return api.newGetCompanySettings(companyId);
    }
    return api.oldGetCompanySettings(companyId);
  }
)

export const updateCompanySettings = createAsyncThunk(
  'companyAdmin/updateCompanySettings',
  async (params) => {
    if (KPConfig.useNewBe) {
      return api.newUpdateCompanySettings(params);
    }
    return api.oldUpdateCompanySettings(params);
  }
)

export const companyAdminSlice = createSlice({
  name: 'companyAdmin',
  initialState,
  reducers: {
    resetCompanyAdminSettingsState: (state) => {
      state.getCompanySettingsStatus = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanySettings.pending, (state) => {
        state.getCompanySettingsStatus = "loading";
        state.didLoadCompanySettings = false;
      })     
      .addCase(getCompanySettings.fulfilled, (state, action) => {
        state.settings = action.payload.body;
        state.getCompanySettingsStatus = "idle";
        state.didLoadCompanySettings = true;
      })
      .addCase(getCompanySettings.rejected, (state) => {
        state.getCompanySettingsStatus = "error";
        state.didLoadCompanySettings = false;
      })

      .addCase(updateCompanySettings.pending, (state, action) => {
        const { name } = action.meta.arg;
        const { settings } = state;

        if (action.meta.arg.newProviderValue) {
          state[action.meta.arg.newProviderValue + "ProviderStatus"] = "saving";
        }
        state.originalSettings = [...settings];
        state[name+"Status"]= "saving";

        if (settings.length === 0) {
          settings.push(action.meta.arg);
          return;
        }

        const isSettingNameInState = settings.some(item => item.name === name);
          
        if (!isSettingNameInState) {
          settings.push(action.meta.arg);
          return;
        }

        const settingIndex = settings.findIndex(setting => setting.name == name);

        if (settingIndex > -1) {
          settings[settingIndex] = action.meta.arg;
        }

      })
      .addCase(updateCompanySettings.fulfilled, (state, action) => {
        if (action.meta.arg.newProviderValue) {
          state[action.meta.arg.newProviderValue + "ProviderStatus"] = "idle";
        }
        state[action.meta.arg.name+"Status"]= "idle";
      })
      .addCase(updateCompanySettings.rejected, (state, action) => {
        if (action.meta.arg.newProviderValue) {
          state[action.meta.arg.newProviderValue + "ProviderStatus"] = "idle";
        }
        state.settings = state.originalSettings;
        state[action.meta.arg.name+"Status"]= "idle";
      })
  }
});

export const {
  resetCompanyAdminSettingsState,
} = companyAdminSlice.actions;

export const selectCompanySettingStatus = (state, companySetting) => {
  return state.companyAdmin[companySetting+"Status"] || "idle"; 
}
export const selectProviderStatus = (state, providerName) => {
  return state.companyAdmin[providerName+"ProviderStatus"] || "idle";
}
export const selectDidLoadCompanySettings = (state) => state.companyAdmin.didLoadCompanySettings;
export const selectGetCompanySettingsStatus = (state) => state.companyAdmin.getCompanySettingsStatus;
export const selectCompanySetting = (state, settingName) => {
  if (!settingName || typeof settingName !== "string") {
    throw new Error("Invalid settingName argument");
  }

  const { settings } = state.companyAdmin;

  const matchingSetting = settings.find(setting => setting.name === settingName);

  if (!matchingSetting) {
    return null;
  }

  if (matchingSetting.value) {
    switch (settingName) {
      case "login_providers-allowed":
      case "root_folder_objects-enabled":
        return matchingSetting.value.split(",");
      default:
        return matchingSetting.value;
    }
  } else {
    return  [];
  }
}

export default companyAdminSlice.reducer;
